import DataLoader from "dataloader"
import { useSuspenseQuery } from "@tanstack/react-query"
import { get } from "../typed-client/get"

const loader = new DataLoader(
  async (keys: readonly number[]) => {
    const results = await get("/api/ShiftType/GetShiftTypes", null)
    return keys.map((key) => results?.find((x) => x.shiftTypeId === key))
  },
  { batchScheduleFn: (callback) => setTimeout(callback, 100) }
)

export function useBatchedShiftTypes(key: number) {
  return useSuspenseQuery({
    queryKey: ["ShiftType", key],
    queryFn: () => loader.load(key),
    gcTime: 1000 * 60 * 60, // 1 hour
    staleTime: 1000 * 60 * 60, // 1 hor
  })
}
